// Diversos dominios sobre los que realizar pruebas
export var global = {
  // url: 'http://api-rest-laravel.com.devel/api/',
  // entorno: 'local',

  // url: 'https://test-aximenor.es/api/',
  // entorno: 'preproduccion',

  url: 'https://floresjm.es/api/',
  entorno: 'produccion',

  appList: [
    {
      app: 'set-online',
      available: false,
      type: 'function',
      icon: 'pi pi-power-off',
      title: 'Trabajar',
      text: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Inventore sed consequuntur error repudiandae numquam deserunt quisquam repellat libero asperiores earum nam nobis, culpa ratione quam perferendis esse, cupiditate neque quas!',
      redirect: 'none',
    },
    {
      app: 'pc',
      available: false,
      type: 'app',
      icon: 'pi pi-shield',
      title: 'P. Control',
      text: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Inventore sed consequuntur error repudiandae numquam deserunt quisquam repellat libero asperiores earum nam nobis, culpa ratione quam perferendis esse, cupiditate neque quas!',
      redirect: 'PANEL_CONTROL',
    },
    // {
    //   app: 'taller',
    //   available: false,
    //   type: 'app',
    //   icon: 'pi pi-compass',
    //   title: 'Taller',
    //   text: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Inventore sed consequuntur error repudiandae numquam deserunt quisquam repellat libero asperiores earum nam nobis, culpa ratione quam perferendis esse, cupiditate neque quas!',
    //   redirect: 'PANEL_CONTROL'
    // },
    {
      app: 'cola',
      available: false,
      type: 'app',
      icon: 'pi pi-desktop',
      title: 'Cola',
      text: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Inventore sed consequuntur error repudiandae numquam deserunt quisquam repellat libero asperiores earum nam nobis, culpa ratione quam perferendis esse, cupiditate neque quas!',
      redirect: 'COLA',
    },
    {
      app: 'logistica',
      available: false,
      type: 'app',
      icon: 'pi pi-map-marker',
      title: 'Logistica',
      text: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Inventore sed consequuntur error repudiandae numquam deserunt quisquam repellat libero asperiores earum nam nobis, culpa ratione quam perferendis esse, cupiditate neque quas!',
      redirect: 'LOGISTICA',
    },
    // {
    //   app: 'mostrador',
    //   available: false,
    //   type: 'app',
    //   icon: 'pi pi-shopping-cart',
    //   title: 'Mostrador',
    //   text: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Inventore sed consequuntur error repudiandae numquam deserunt quisquam repellat libero asperiores earum nam nobis, culpa ratione quam perferendis esse, cupiditate neque quas!',
    //   redirect: 'MOSTRADOR'
    // },
    {
      app: 'gpsc',
      available: false,
      type: 'app',
      icon: 'pi pi-tags',
      title: 'GPSC',
      text: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Inventore sed consequuntur error repudiandae numquam deserunt quisquam repellat libero asperiores earum nam nobis, culpa ratione quam perferendis esse, cupiditate neque quas!',
      redirect: 'GPSC',
    },
    {
      app: 'age',
      available: false,
      type: 'app',
      icon: 'pi pi-id-card',
      title: 'AGE',
      text: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Inventore sed consequuntur error repudiandae numquam deserunt quisquam repellat libero asperiores earum nam nobis, culpa ratione quam perferendis esse, cupiditate neque quas!',
      redirect: 'AGE',
    },
    {
      app: 'ghp',
      available: false,
      type: 'app',
      icon: 'pi pi-calendar',
      title: 'GHP',
      text: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Inventore sed consequuntur error repudiandae numquam deserunt quisquam repellat libero asperiores earum nam nobis, culpa ratione quam perferendis esse, cupiditate neque quas!',
      redirect: 'GHP',
    },
    {
      app: 'set-offline',
      available: false,
      type: 'function',
      icon: 'pi pi-power-off',
      title: 'Dejar de trabajar',
      text: 'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Inventore sed consequuntur error repudiandae numquam deserunt quisquam repellat libero asperiores earum nam nobis, culpa ratione quam perferendis esse, cupiditate neque quas!',
      redirect: 'none',
    },
  ],

  redireccionesLocal(spas: string): string {
    switch (spas) {
      case 'PANEL_CONTROL':
        return 'http://localhost:4200/';
      case 'TALLER':
        return 'https://test-aximenor.es/panel-control/';
      case 'COLA':
        return 'http://localhost:4203';
      case 'ALMACEN':
        return 'https://test-aximenor.es/panel-control/';
      case 'LOGISTICA':
        return 'https://test-aximenor.es/logistica/';
      case 'KIOSKO':
        return 'https://test-aximenor.es/kiosko/';
      case 'TANATORIO':
        return 'https://test-aximenor.es/tanatorios/';
      case 'ECARE':
        return 'https://test-aximenor.es/ecare/';
      case 'AGE':
        return 'https://test-aximenor.es/age/';
      case 'GHP':
        return 'http://localhost:4210';
      case 'GPSC':
        return 'https://test-aximenor.es/gpsc/';
      default:
        return 'https://test-aximenor.es/error/';
    }
  },

  redireccionesPreproduccion(spas: string): string {
    switch (spas) {
      case 'PANEL_CONTROL':
        return 'https://test-aximenor.es/panel-control/';
      case 'TALLER':
        return 'https://test-aximenor.es/panel-control/';
      case 'COLA':
        return 'https://test-aximenor.es/colas/';
      case 'ALMACEN':
        return 'https://test-aximenor.es/panel-control/';
      case 'LOGISTICA':
        return 'https://test-aximenor.es/logistica/';
      case 'KIOSKO':
        return 'https://test-aximenor.es/kiosko/';
      case 'TANATORIO':
        return 'https://test-aximenor.es/tanatorios/';
      case 'ECARE':
        return 'https://test-aximenor.es/ecare/';
      case 'AGE':
        return 'https://test-aximenor.es/age/';
      case 'GHP':
        return 'https://test-aximenor.es/ghp/';
      case 'GPSC':
        return 'https://test-aximenor.es/gpsc/';
      default:
        return 'https://test-aximenor.es/error/';
    }
  },

  redirecciones(spas: string): string {
    switch (spas) {
      case 'PANEL_CONTROL':
        return 'https://floresjm.es/panel-control/';
      case 'TALLER':
        return 'https://floresjm.es/panel-control/';
      case 'COLA':
        return 'https://floresjm.es/colas/';
      case 'ALMACEN':
        return 'https://floresjm.es/panel-control/';
      case 'LOGISTICA':
        return 'https://floresjm.es/logistica/';
      case 'KIOSKO':
        return 'https://floresjm.es/kiosko/';
      case 'TANATORIO':
        return 'https://floresjm.es/tanatorios/';
      case 'ECARE':
        return 'https://floresjm.es/ecare/';
      case 'AGE':
        return 'https://floresjm.es/age/';
      case 'GHP':
        return 'https://floresjm.es/ghp/';
      case 'GPSC':
        return 'https://floresjm.es/gpsc/';
      default:
        return 'https://floresjm.es/error/';
    }
  },
};
